import {AdaptedSelectIdDataSource} from "../../tables";
import {SelectIdContextModal} from "./SelectIdContextModal";
import {BomsDataSource} from "../../../pages/boms/bom-table/BomTable";
import {useCallback} from "react";

export function CopyBomModal() {
	const dataSourceCtor = useCallback((q) => {
		return new AdaptedSelectIdDataSource(
			new BomsDataSource(q)
		);
	}, []);

	return (
		<SelectIdContextModal
			dataSourceCtor={dataSourceCtor}
			title={subject => `Assign copy of BOM to: ${subject.title}`}
			expectedType={'copy_bom'}
		/>
	);
}